
/**
 * 
 * @hidden
 */
export enum MappingTypes {

    /**
     * 
     */
    LegacyGrid = 1,

    /**
     * 
     */
    LegacyForm = 2,

    /**
     * 
     */
    LegacyTree = 3,

    /**
     * 
     */
    Grid = 4,

    /**
     * 
     */
    Form = 5,

    /**
     * 
     */
    Tree = 6,
}
